export default function collapsibles() {

    // collapse + header nav (kan zowel voor navs als voor collapsable items gebruikt worden, zoals een read more / less, zie: https://detoekomsten.dev.devplus.be/#proces,
    // je kan werken met href gelinkte items (zie: https://github.com/devplus-be/les-futurs/blob/07999be2bf48cace42af499352f511ae8ac3c907/themes/les-futurs/template-home.php#L117 of via [data-toggle-for], zie: https://github.com/devplus-be/les-futurs/blob/main/themes/les-futurs/header.php#L162
    const collapsing_items = document.querySelectorAll( '[data-toggle="collapse"]' );

    if ( collapsing_items.length ) {

        collapsing_items.forEach( ( item, index ) => {

			if ( ! item.classList.contains( 'has-listener' ) ) {

				item.addEventListener( 'click', function( e ) {

					e.preventDefault();

					// doe niks als de transitie nog bezig is.
					if ( ! this.classList.contains( 'transitioning' ) ) {

						var href = this.getAttribute( 'href' );
						var toggler_for = this.getAttribute( 'data-toggle-for' );

						var item;
						var anchor = this;

						let label = anchor.querySelector( '.label' );

						if ( href ) {

							item = document.querySelector( '.collapse-content#' + href.replace( '#', '' ) );

						} else if ( toggler_for ) {

							item = document.querySelector( toggler_for );

						}

						if ( item ) {

							anchor.classList.add( 'transitioning' );

							if ( this.classList.contains( 'collapsed' ) ) {

								this.setAttribute( 'aria-expanded', 'true' );

								item.classList.remove( 'collapse' );
								item.classList.add( 'collapsing' );

								let item_open_transitionend = function() {

									item.removeEventListener( 'transitionend', item_open_transitionend );

									item.classList.remove( 'collapsing' );
									item.classList.add( 'collapse', 'show' );

									item.removeAttribute( 'style' );

									item.classList.remove( 'collapsed' );

									anchor.classList.remove( 'transitioning', 'collapsed' );

								};

								item.addEventListener( 'transitionend', item_open_transitionend );

								item.style.height = item.scrollHeight + 'px';

								if ( label ) {

									label.innerHTML = anchor.getAttribute( 'data-label-less' );

								}

							} else {

								this.setAttribute( 'aria-expanded', 'false' );

								item.style.height = item.getBoundingClientRect()['height'] + 'px';

								item.offsetHeight; // paint

								if ( label ) {

									label.innerHTML = anchor.getAttribute( 'data-label-more' );

								}

								item.classList.remove( 'collapse', 'show' );
								item.classList.add( 'collapsing' );

								item.removeAttribute( 'style' );

								let item_close_transitionend = function() {

									item.removeEventListener( 'transitionend', item_close_transitionend );

									item.classList.remove( 'collapsing' )
									item.classList.add( 'collapse' );

									anchor.classList.remove( 'transitioning' );
									anchor.classList.add( 'collapsed' );

								}

								item.addEventListener( 'transitionend', item_close_transitionend );

							}

						}

					}

				} );

				item.classList.add( 'has-listener' );

			}

        } );

    }

}